var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"notification-button",attrs:{"icon":""}},[_c('v-badge',{attrs:{"color":"#d90570","overlap":"","value":_vm.unreadCount,"content":_vm.unreadCount}},[_c('v-icon',[_vm._v("mdi-bell-outline")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }